import axios from '@/services/axios';
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'

interface ProductProfile {
    [key: string]: any;
}

const createProductProfile = async (
    productProfile: ProductProfile,
    update?: boolean
): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios('/productProfiles/', update ? 'PUT' : 'POST', productProfile)
        .then(response => {
            console.log('response -->', response);
            notifyOnboardingStatusChanged()
            resolve(response);
        })
        .catch(error => reject(error));
    });
};

export default createProductProfile;
